import styled from 'styled-components';

export const AcoesAnexo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const DocumentoAnexado = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #24a95d;
  font-size: 14px;
  font-weight: bold;
`;

export const Instrucoes = styled.p`
  color: #707070;
  margin-bottom: 16px;
`;

export const AreaColar = styled.div`
  min-height: 180px;
  margin-bottom: 12px;
  padding: 16px;
  border: 2px dashed #bdbdbd;
  border-radius: 4px;
  background: #f7f8f9;
  color: #707070;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  outline: none;

  &:focus,
  &:hover {
    border-color: #24a95d;
  }

  .anticon {
    color: #24a95d;
    font-size: 28px;
  }
`;

export const Preview = styled.img`
  display: block;
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
`;

export const NomeArquivo = styled.p`
  color: #707070;
  margin-bottom: 12px;
  overflow-wrap: anywhere;
`;
